<nav aria-label="Breadcrumb" class="text-sm text-on-surface-variant mb-6">
  <ol class="flex flex-wrap items-center gap-2" itemscope itemtype="https://schema.org/BreadcrumbList">
    @for (crumb of crumbs; track crumb.label; let i = $index; let last = $last) {
      <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem" class="flex items-center gap-2">
        @if (!last && crumb.url) {
          <a [routerLink]="crumb.url" itemprop="item" class="hover:text-primary transition-colors">
            <span itemprop="name">{{ crumb.label }}</span>
          </a>
        } @else {
          <span itemprop="name" class="text-on-surface font-medium" aria-current="page">{{ crumb.label }}</span>
        }
        <meta itemprop="position" [content]="i + 1" />
        @if (!last) {
          <span class="material-symbols-outlined text-base">chevron_right</span>
        }
      </li>
    }
  </ol>
</nav>
